export const normalizeSearchQuery = (query: string): string =>
  query.trim().toLowerCase();

export const matchesSearchQuery = (
  normalizedQuery: string,
  fields: Array<string | undefined>
): boolean => {
  if (!normalizedQuery) {
    return true;
  }

  return fields.some(field => field?.toLowerCase().includes(normalizedQuery));
};
